// Même paire d'arrêts prévue et réelle : les kilomètres ne se comparent pas si un autre site s'intercale.
export function routeComparisons(truck) {
  const plan = truck?.plan, cmp = truck?.comparison;
  if (!plan?.sites?.length || !cmp) return [];
  const sites = cmp.sites || [];
  const ends = [{ name: "Dépôt", departure: plan.departure, realDeparture: cmp.real_departure,
    lat: plan.depot?.[0], lon: plan.depot?.[1] },
  ...plan.sites.map((s, i) => ({ ...s, realArrival: sites[i]?.real_arrival,
    realDeparture: sites[i]?.open_end ? null : sites[i]?.real_departure, device: sites[i]?.real_device_id })),
  { name: "Dépôt", arrival: plan.return_at, realArrival: cmp.real_return,
    leg_km: plan.return_km, leg_geometry: plan.return_geometry, lat: plan.depot?.[0], lon: plan.depot?.[1] }];
  return ends.slice(1).flatMap((to, i) => {
    const from = ends[i];
    if (!(to.arrival > from.departure)) return [];
    const start = from.realDeparture, end = to.realArrival;
    const interrupted = sites.some(s => s.real_arrival > start && s.real_arrival < end);
    const switched = from.device && to.device && from.device !== to.device;
    const used = (truck.trucks_used || []).filter(u => u.start < end && u.end > start);
    const devices = [...new Set(used.map(u => u.device_id))];
    const deviceId = to.device || from.device || devices[0] || truck.device_id;
    const comparable = start != null && end != null && end > start && !interrupted && !switched && devices.length <= 1;
    const visits = comparable ? (cmp.visits || []).filter(v => v.arr > start && v.arr <= end) : [];
    const km = visits.length && visits.every(v => Number.isFinite(v.km) && v.km >= 0)
      ? visits.reduce((sum, v) => sum + v.km, 0) : null;
    const plannedKm = Number.isFinite(to.leg_km) ? to.leg_km : null;
    return [{ id: i, name: `${from.name} → ${to.name}`, from, to, plannedKm, realKm: km,
      gap: km != null && plannedKm != null ? km - plannedKm : null,
      plannedLine: to.leg_geometry || [],
      trace: comparable && deviceId ? { deviceId, fromMin: start, toMin: end } : null,
      reason: switched || devices.length > 1 ? "Changement de camion : ce trajet ne peut pas être comparé directement."
        : interrupted ? "Le camion a visité un autre arrêt avant cette arrivée : les trajets ne sont pas directement comparables."
          : "Les heures de départ ou d’arrivée Geotab ne permettent pas de délimiter ce trajet.",
    }];
  });
}

export function defaultRouteId(routes) {
  return [...routes].sort((a, b) => Math.abs(b.gap ?? 0) - Math.abs(a.gap ?? 0))[0]?.id ?? null;
}
